import React from "react";

const ArticleReferences = () => {
  return (
    <div>
      <div className="mt-20 mb-20">
        <h2 id="references"> References </h2>
        <ol type="1">
          <li id="reference1">
            {" "}
            LBP future <br />{" "}
            <a href="https://www.nature.com/articles/s41467-020-15508-1">
              {" "}
              Developing a new class of engineered live bacterial therapeutics
              to treat human diseases. Mark R. Charbonneau, Vincent M. Isabella,
              Ning Li & Caroline B. Kurtz Nature Communications volume 11,
              Article number: 1738 (2020){" "}
            </a>{" "}
          </li>
          <li id="reference2">
            {" "}
            ARGs <br />{" "}
            <a href="https://www.nature.com/articles/s41467-022-29283-8">
              {" "}
              Assessment of global health risk of antibiotic resistance genes.
              Zhenyan Zhang, Qi Zhang, Tingzhang Wang, Nuohan Xu, Tao Lu, Wenjie
              Hong, Josep Penuelas, Michael Gillings, Meixia Wang, Wenwen Gao &
              Haifeng Qian Nature Communications volume 13, Article number: 1553
              (2022){" "}
            </a>{" "}
          </li>
          <li id="reference3">
            {" "}
            DUT mutation <br />{" "}
            <a href="https://europepmc.org/article/MED/16908222">
              {" "}
              Quantitative determination of uracil residues in Escherichia coli DNA: 
              Contribution of ung, dug, and dut genes to uracil avoidance.
              Lari SU, Chen CY , Vertéssy BG , Morré J ,Bennett SE, DNA Repair, 14 Aug 2006, 5(12):1407-1420{" "}
            </a>{" "}
          </li>
        </ol>
      </div>
    </div>
  );
};

export default ArticleReferences;
